function normalizePathPart(v) {
  return String(v ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/**
 * Walks existing folder segments on a flat project-items list. Does not create folders.
 * @returns {{ parentId: number|null, pathResolved: boolean }}
 */
export function walkExistingFolderPathInItems(items, folderPath) {
  if (!Array.isArray(folderPath) || folderPath.length === 0) {
    return { parentId: null, pathResolved: true };
  }
  let parentId = null;
  for (const seg of folderPath.map(normalizePathPart)) {
    if (!seg) continue;
    const currentParentId = parentId;
    const folder = items.find(
      (it) =>
        it?.item_type === "folder" &&
        (it?.parent_id ?? null) === currentParentId &&
        normalizePathPart(it?.name) === seg
    );
    if (!folder) {
      return { parentId, pathResolved: false };
    }
    parentId = folder.id;
  }
  return { parentId, pathResolved: true };
}

/**
 * @param {string[]} folderPath
 * @returns {string[]}
 */
export function normalizeStoreProjectFolderPath(folderPath) {
  if (!Array.isArray(folderPath)) return [];
  return folderPath
    .map((seg) => String(seg ?? "").trim())
    .filter(Boolean);
}
